import search from '~/assets/icons/search.svg';
import friends from '~/assets/icons/friends.svg';
import message from '~/assets/icons/message.svg';
import star from '~/assets/icons/star.svg';

import { AppMessageSearchTab } from '../AppMessageSearchTab';
import { AppMessageFriendsTab } from '../AppMessageFriendsTab';
import { AppMessageFavoritesTab } from '../AppMessageFavoritesTab';
import { AppMessageDialogsTab } from '../AppMessageDialogsTab';

export enum AppMessageMenu {
	Search = 'search',
	Friends = 'friends',
	Messages = 'messages',
	Favorite = 'favorite',
}

export const appMessageMenuIcons = {
	[AppMessageMenu.Search]: search,
	[AppMessageMenu.Friends]: friends,
	[AppMessageMenu.Messages]: message,
	[AppMessageMenu.Favorite]: star,
};

export const appMessageMenuNames = {
	[AppMessageMenu.Search]: 'Поиск',
	[AppMessageMenu.Friends]: 'Друзья',
	[AppMessageMenu.Messages]: 'Диалоги',
	[AppMessageMenu.Favorite]: 'Избранное',
};

export const appMessageTabs = {
	[AppMessageMenu.Search]: AppMessageSearchTab,
	[AppMessageMenu.Friends]: AppMessageFriendsTab,
	[AppMessageMenu.Messages]: AppMessageDialogsTab,
	[AppMessageMenu.Favorite]: AppMessageFavoritesTab,
};
